module.exports = __webpack_public_path__ + "img/recmember.0baaff01.jpg";